export default ['/login', '/hr/Registration', '/public/kuakua'];
